import React from "react"
import propTypes from "prop-types"
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap"

const CashCutDetailsModal = ({ isOpen, toggle, item, businessInfo, onPrint }) => {
  if (!item) return null

  const toNumber = (value) => Number(value ?? 0)
  const businessName = businessInfo?.name || businessInfo?.business_name || "-"
  const businessAddress = businessInfo?.street || "-"
  const neighborhood = businessInfo?.neighborhood || "-"

  const date = new Date(item.date)
  const printDate = new Intl.DateTimeFormat("es-MX", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).format(date)

  const formatMoney = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(Number(value ?? 0))
  }

  const salesIVA = toNumber(item.sales_with_iva)
  const salesIEPS8 = toNumber(item.sales_with_ieps8)
  const salesSYS = toNumber(item.sales_without_tax)
  const totalIncome = Number(item.total_cash || 0) + Number(item.card_pay || 0) + Number(item.transfer_pay || 0)
  const salesTotalCut = salesIVA + salesIEPS8 + salesSYS
  const salesTaxIVA = toNumber(item.iva_tax)
  const salesTaxIEPS8 = toNumber(item.ieps8_tax)

  const invoicedIVA = toNumber(item.invoiced_sales_with_iva)
  const invoicedIEPS8 = toNumber(item.invoiced_sales_with_ieps8)
  const invoicedSYS = toNumber(item.invoiced_sales_without_tax)
  const invoicedTaxIVA = toNumber(item.invoiced_iva_tax)
  const invoicedTaxIEPS8 = toNumber(item.invoiced_ieps8_tax)
  const invoicedTotal = invoicedIVA + invoicedIEPS8 + invoicedSYS

  const diffIVA = salesIVA - invoicedIVA
  const diffIEPS8 = salesIEPS8 - invoicedIEPS8
  const diffSYS = salesSYS - invoicedSYS
  const diffTaxIVA = diffIVA > 0 ? diffIVA - diffIVA / 1.16 : 0
  const diffTaxIEPS8 = diffIEPS8 > 0 ? diffIEPS8 - diffIEPS8 / 1.08 : 0

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true} size="md" backdrop={true}>
      <ModalHeader toggle={toggle}>Detalle del Corte</ModalHeader>
      <ModalBody style={{ padding: "0px" }}>
        <div style={{ maxHeight: "62vh", overflowY: "auto", padding: "1rem" }}>
        <div style={{ fontFamily: "monospace", fontSize: "13px" }}>
          <div style={{ textAlign: "center", fontWeight: 700 }}>*** CORTE CAJA EN MONEDA:MN ***</div>
          <div style={{ textAlign: "center", fontWeight: 700 }}>{businessName}</div>
          <br />
          <div style={{ textAlign: "center" }}>{businessAddress}</div>
          <div style={{ textAlign: "center" }}>{neighborhood}</div>
          <br />
          <div style={{ textAlign: "center", fontWeight: 700 }}>CAJA1 {printDate}</div>

          <div style={{ fontWeight: 700, marginTop: 12 }}>** Ingresos **</div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Clientes Efectivo:</span>
            <span>{formatMoney(item.total_cash)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Clientes Tarjeta:</span>
            <span>{formatMoney(item.card_pay)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Clientes Transferencia:</span>
            <span>{formatMoney(item.transfer_pay)}</span>
          </div>
          <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />
          <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700 }}>
            <span>Total de Ingresos:</span>
            <span>{formatMoney(totalIncome)}</span>
          </div>

          <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />
          <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />

          <div style={{ textAlign: "center", fontWeight: 700, marginTop: 8 }}>******* VENTAS DEL CORTE *******</div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Ventas IVA:</span>
            <span>{formatMoney(salesIVA)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Ventas IEPS8:</span>
            <span>{formatMoney(salesIEPS8)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Ventas Impuesto 0:</span>
            <span>{formatMoney(salesSYS)}</span>
          </div>

          <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />

          <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700 }}>
            <span>Venta total del Corte:</span>
            <span>{formatMoney(salesTotalCut)}</span>
          </div>

          <br />

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Impuesto IVA:</span>
            <span>{formatMoney(salesTaxIVA)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Impuesto IEPS8:</span>
            <span>{formatMoney(salesTaxIEPS8)}</span>
          </div>

          <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />
          <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />

          <div style={{ fontWeight: 700, marginTop: 8 }}>** Ingresos Facturados **</div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Ventas IVA:</span>
            <span>{formatMoney(invoicedIVA)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Ventas IEPS8:</span>
            <span>{formatMoney(invoicedIEPS8)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Ventas Impuesto 0:</span>
            <span>{formatMoney(invoicedSYS)}</span>
          </div>
          <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Venta total facturada:</span>
            <span>{formatMoney(invoicedTotal)}</span>
          </div>

          <br />

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Impuesto IVA:</span>
            <span>{formatMoney(invoicedTaxIVA)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Impuesto IEPS8:</span>
            <span>{formatMoney(invoicedTaxIEPS8)}</span>
          </div>

          <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />
          <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />

          <div style={{ fontWeight: 700, marginTop: 8 }}>****Venta total - ventas facturadas****</div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Ventas IVA:</span>
            <span>{formatMoney(diffIVA)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Ventas IEPS8:</span>
            <span>{formatMoney(diffIEPS8)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Ventas Impuesto 0:</span>
            <span>{formatMoney(diffSYS)}</span>
          </div>

          <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Impuesto IVA:</span>
            <span>{formatMoney(diffTaxIVA)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Impuesto IEPS8:</span>
            <span>{formatMoney(diffTaxIEPS8)}</span>
          </div>
        </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cerrar
        </Button>
        <Button
          color="success"
          onClick={() => {
            if (onPrint) {
              onPrint(item)
            }
          }}
        >
          Imprimir
        </Button>
      </ModalFooter>
    </Modal>
  )
}

CashCutDetailsModal.propTypes = {
  isOpen: propTypes.any,
  toggle: propTypes.func,
  item: propTypes.object,
  businessInfo: propTypes.object,
  onPrint: propTypes.func,
}

export default CashCutDetailsModal
